import keymirror from 'keymirror';
import { request } from 'js/api/axios';
import { callApi } from '../api';
import { SCHEMAS } from '../api/schemas';
import { spreadApiKeys, extractApiKeys } from '../utils';
import { isNullOrWhitespace } from 'js/utils/string';

export const types = keymirror({
  ...spreadApiKeys('LIST_USER_GROUP_MEMBERS'),
  ...spreadApiKeys('UPDATE_USER_GROUP_MEMBER'),
  ...spreadApiKeys('LIST_USER_GROUP_MEMBER_COHORTS'),
  ...spreadApiKeys('CREATE_USER_GROUP_MEMBER_COHORT'),
  ...spreadApiKeys('UPDATE_USER_GROUP_MEMBER_COHORT'),
  ...spreadApiKeys('DELETE_USER_GROUP_MEMBER_COHORT'),
});

export function list(workspaceId, search) {
  const data = isNullOrWhitespace(search) ? {} : { search };
  return (dispatch) => {
    return callApi(
      {
        types: extractApiKeys(types.LIST_USER_GROUP_MEMBERS, types),
        request: (data, token) =>
          request.get(
            `/api/workspaces/${workspaceId}/user-group-members?search=${search}`,
            {
              params: data,
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          ),
        data,
        schema: SCHEMAS.USER_GROUP_MEMBER_ARRAY,
      },
      dispatch
    );
  };
}

export function update(patch) {
  return (dispatch) => {
    return callApi(
      {
        types: extractApiKeys(types.UPDATE_USER_GROUP_MEMBER, types),
        request: (data, token, currentWorkspaceId) =>
          request.put(
            `/api/workspaces/${currentWorkspaceId}/user_group_members/${patch.id}`,
            data,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          ),
        data: { user_group_member: patch },
        meta: { patch: { user_group_members: { [patch.id]: patch } } },
        schema: SCHEMAS.USER_GROUP_MEMBER,
      },
      dispatch
    );
  };
}

export function listCohorts(userGroupId, queryId) {
  return (dispatch) => {
    return callApi(
      {
        types: extractApiKeys(types.LIST_USER_GROUP_MEMBER_COHORTS, types),
        request: (_data, token, currentWorkspaceId) =>
          request.get(
            `/api/workspaces/${currentWorkspaceId}/user-groups/${userGroupId}/members`,
            { headers: { Authorization: `Bearer ${token}` } }
          ),
        meta: { queryId },
        schema: SCHEMAS.USER_GROUP_MEMBER_COHORT_ARRAY,
      },
      dispatch
    );
  };
}

export function createCohort(userGroupId, memberCohort) {
  return (dispatch) => {
    return callApi(
      {
        types: extractApiKeys(types.CREATE_USER_GROUP_MEMBER_COHORT, types),
        request: (data, token, currentWorkspaceId) =>
          request.post(
            `/api/workspaces/${currentWorkspaceId}/user-groups/${userGroupId}/members`,
            data,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          ),
        data: { user_group_member_cohort: memberCohort },
        schema: SCHEMAS.USER_GROUP_MEMBER_COHORT,
      },
      dispatch
    );
  };
}

export function updateCohort(userGroupId, memberCohortPatch) {
  console.log({ memberCohortPatch });
  return (dispatch) => {
    return callApi(
      {
        types: extractApiKeys(types.UPDATE_USER_GROUP_MEMBER_COHORT, types),
        request: (data, token, currentWorkspaceId) =>
          request.put(
            `/api/workspaces/${currentWorkspaceId}/user-groups/${userGroupId}/members/${memberCohortPatch.user_group_member_id}`,
            data,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          ),
        data: { user_group_member_cohort: memberCohortPatch },
        schema: SCHEMAS.USER_GROUP_MEMBER_COHORT,
      },
      dispatch
    );
  };
}

export function deleteCohort(userGroupId, memberCohortId) {
  return (dispatch) => {
    return callApi(
      {
        types: extractApiKeys(types.DELETE_USER_GROUP_MEMBER_COHORT, types),
        request: (_data, token, currentWorkspaceId) =>
          request.delete(
            `/api/workspaces/${currentWorkspaceId}/user-groups/${userGroupId}/members/${memberCohortId}`,
            { headers: { Authorization: `Bearer ${token}` } }
          ),
      },
      dispatch
    );
  };
}
